import React, { useState } from "react";
import { Box } from "@mui/joy";
import Sidenav from "./Components/Sidenav";
import HeaderNav from "./Components/HeaderNav";

export default function MainLayout({ children }) {

    const [open, setOpen] = useState(false);

    const sidebarWidth = open ? 224 : 72;
    const headerWidth = sidebarWidth+20;
    return (

        <Box sx={{ display: "flex" }}>

            <Box
                sx={{
                    position: "fixed",
                    width: sidebarWidth,
                    top: 0,
                    left: 0,
                    bottom: 0,
                    transition: "width .3s"
                }}
            >

                <Sidenav
                    open={open}
                    setOpen={setOpen}
                />

            </Box>

            <Box
                sx={{
                    marginLeft: `${headerWidth}px`,
                    width: `calc(100% - ${sidebarWidth}px)`,
                    transition: ".3s",
                    opacity: 1,backgroundColor: "white",
                }}
            >

                <HeaderNav />

                <Box p={2}>
                    {children}
                </Box>

            </Box>

        </Box>

    );

}